import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { Header } from "components/DisplayBox";
import { H3 } from "components/Text";
import Card from "components/Card";
import { colors } from "style";

/**
 * CardSection
 *
 * @param {String} titleMsgId
 * @param {React.ReactNode} children
 */
const ApplicantSectionWithTitle = ({ titleMsgId, children }) => (
  <>
    <Header css={styles.header} noUnderline>
      <H3 css={styles.title}>
        <FormattedMessage id={titleMsgId} />
      </H3>
    </Header>

    <Card css={styles.card}>{children}</Card>
  </>
);

const styles = {
  header: css`
    margin: 0;
    padding: 1rem 1.5rem;

    background: ${colors.purpleRainLight5};
    border: 1px solid ${colors.grayAnatomyLight4};
    border-bottom: 0;
    border-radius: 8px 8px 0 0;

    color: ${colors.purpleRainBase};
  `,

  title: css`
    margin: 0;
    font-weight: 600;
  `,

  card: css`
    border-radius: 0 0 8px 8px;
  `,
};

ApplicantSectionWithTitle.propTypes = {
  titleMsgId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default ApplicantSectionWithTitle;
